/* global Stripe */

import { t } from 'default/translate_override.js'

let card, cardErr, cardExp, cardExpErr, cvc, cvcErr, displayError, elements, stripe

let style = {
  base: {
    fontSize: '14px',
    '::placeholder': {
      color: '#999999'
    }
  }
}

function createElement(stripeElement, errorDiv, id, placeholder) {
  let variable = elements.create(stripeElement, { style: style, placeholder: placeholder })
  variable.mount(id)

  variable.addEventListener('change', function(event) {
    if (event.error) {
      errorDiv.textContent = event.error.message
    } else {
      errorDiv.textContent = ''
      displayError.textContent = ''
    }
  })

  return variable
}

function mountElements() {
  displayError = document.getElementById('card-errors')
  cardErr = document.getElementById('cardErr')
  cardExpErr = document.getElementById('cardExpErr')
  cvcErr = document.getElementById('cvcErr')

  card = createElement('cardNumber', cardErr, '#card-number', t('creditCardNumber'))
  cvc = createElement('cardCvc', cvcErr, '#card-cvc', t('cVV'))
  cardExp = createElement('cardExpiry', cardExpErr, '#card-exp', t('expirationDate'))
}

export default {
  addErrorMessage(message) {
    displayError.textContent = message
  },

  cardIDToBeChargedImmediately(billingDetails) {
    return stripe.createPaymentMethod('card', card, {
      billing_details: billingDetails
    }).then(result => {
      if (result.error) {
        this.addErrorMessage(result.error.message)
        return 'error'
      } else {
        return result.paymentMethod.id
      }
    })
  },

  cardIDToBeChargedLater(clientSecret, billingDetails) {
    return stripe.handleCardSetup(
      clientSecret,
      card,
      { payment_method_data: { billing_details: billingDetails } }
    ).then(result => {
      if (result.error) {
        this.addErrorMessage(result.error.message)
        return 'error'
      } else {
        return result.setupIntent.payment_method
      }
    })
  },

  generateForm() {
    stripe = Stripe(window.public_token)
    elements = stripe.elements({ locale: window.locale })
    mountElements()
  },

  paymentIntentSCA(clientSecret) {
    return stripe.handleCardAction(clientSecret).then(result => {
      return result
    })
  },

  removeElements() {
    card.destroy()
    cvc.destroy()
    cardExp.destroy()
  }
}
